import React from 'react';
import { Calendar, Users, ShieldCheck } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';
import { EXPERIENCE_STATS } from '../mock';

const yearsStat = EXPERIENCE_STATS.find((s) => s.label === 'Years in Business');
const clientsStat = EXPERIENCE_STATS.find((s) => s.label === 'Happy Clients');

/**
 * Reused across page headers (Home hero, Contact, Referral, Consultation,
 * Services) so visitors landing directly on any of those pages — not just
 * the homepage — see the same credibility signals immediately.
 */
const TrustStrip = ({ className = '' }) => {
  const { t } = useLanguage();
  return (
    <div className={`flex flex-wrap items-center justify-center gap-x-7 gap-y-2 text-sm font-semibold text-[#0f2540]/80 ${className}`}>
      {yearsStat && (
        <span className="inline-flex items-center gap-1.5">
          <Calendar className="w-4 h-4 text-[#14A098]" />
          {t('hero.trust_years', '{years} Years in Business', { years: yearsStat.value })}
        </span>
      )}
      {clientsStat && (
        <span className="inline-flex items-center gap-1.5">
          <Users className="w-4 h-4 text-[#14A098]" />
          {t('hero.trust_clients', '{clients} Happy Clients', { clients: clientsStat.value })}
        </span>
      )}
      <span className="inline-flex items-center gap-1.5">
        <ShieldCheck className="w-4 h-4 text-[#14A098]" />
        {t('hero.trust_ca', 'CA-verified filings')}
      </span>
    </div>
  );
};

export default TrustStrip;
